import { type IDropdownItem } from 'shared/ui'
import type { Inbox } from 'entities/Inbox/model/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeMoveTo = 'move_to'

type IActionMoveTo = {
  inbox: Inbox
  item: IDropdownItem
  parent?: IDropdownItem
}

export const menuMoveTo = (items: IDropdownItem[]): IDropdownItem => {
  return {
    id: typeMoveTo,
    iconL: 'moveTo',
    iconR: 'chevronRight',
    label: 'Move to',
    children: items,
  }
}

export const actionMoveTo = (
  { inbox, item, parent }: IActionMoveTo,
  store: ConversationMenuStore
) => {
  if (parent?.id === typeMoveTo) {
    if (typeof item.id !== 'number') return

    store.groupsApiMenuStore.onMoveTo(item.id, inbox)
  }
}
